import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0001 10C12.5314 10 14.5834 7.94801 14.5834 5.41671C14.5834 2.8854 12.5314 0.833374 10.0001 0.833374C7.46878 0.833374 5.41675 2.8854 5.41675 5.41671C5.41675 7.94801 7.46878 10 10.0001 10Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16667 3.33333C8.70643 3.33333 8.33333 3.70643 8.33333 4.16667C8.33333 4.6269 8.70643 5 9.16667 5C9.6269 5 10 4.6269 10 4.16667C10 3.70643 9.6269 3.33333 9.16667 3.33333Z",
			fill: "#8C94AA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10V19.1667",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPin);
export default ForwardRef;
